import { render, staticRenderFns } from "./LandingTemplateSRP.vue?vue&type=template&id=b85df422&scoped=true&"
import script from "./LandingTemplateSRP.vue?vue&type=script&lang=js&"
export * from "./LandingTemplateSRP.vue?vue&type=script&lang=js&"
import style0 from "./LandingTemplateSRP.vue?vue&type=style&index=0&id=b85df422&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85df422",
  null
  
)

export default component.exports